import React from 'react';
import { Link } from 'react-router-dom';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="max-w-md w-full text-center">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-ring">404</h1>
          <h2 className="text-2xl font-semibold text-gray-700 mb-4">
            Page Not Found
          </h2>
          <p className="text-view-btn mb-8">
            The page you're looking for doesn't exist or has been moved.
          </p>
        </div>
        
        <div className="space-y-4">
          <Link
            to="/"
            className="inline-block bg-primary text-white px-6 py-3 rounded-lg transition-colors"
          >
            Go Home
          </Link>
          
          <div className="text-sm text-ring">
            <Link to="/login" className="hover:text-gray-700">
              Login
            </Link>
            {' • '}
            <Link to="/registration" className="hover:text-gray-700">
              Register
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
